import { Divider } from "@mui/material";
import { SideNav } from "components";
import { DisplayBox } from "components/OutputBox";
import UploadFile from "components/UploadFile";
import {
  BaseInput,
  LargeButton,
  MainBody,
  OverlayLoader,
  PageTitle,
  Ptag,
} from "components/core";
import routes from "components/routes";
import { Form, Formik } from "formik";
import { WidthLimiter } from "pages/PlanSetup/styles";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router";
import {
  formatToRupees,
  rupeesToNumber,
  formatDate,
  newFormatRupees,
} from "utlis/utils";
import * as Yup from "yup";

function UploadPolicyId() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [isLoading, setLoading] = useState(false);
  const [excelId, setExcelId] = useState("");
  const [pdfId, setPdfId] = useState("");
  const [empSheet, setEmpSheet] = useState("");
  const [grossPremium, setGrossPremium] = useState("");
  const [excelFileName, setExcelFileName] = useState("");
  const [pdfName, setPdfName] = useState("");
  const [empSheetName, setEmpSheetName] = useState("");
  const uploadData = async (values) => {
    if (!excelId || !pdfId) alert("Please Enter UHID's and Invoice.");
    const correctFormat =
      JSON.parse(localStorage.getItem("correct_format")) ?? {};
    const { postFormat, userPlan } = state;
    const productObject = {
      uhid_file_id: excelId,
      userplan_id: userPlan,
      invoice_id: pdfId,
      payment_date: formatDate(values?.date),
      employee_wise_breakup_sheet_id: empSheet,
      amount: rupeesToNumber(values?.premium),
      net_premium: rupeesToNumber(grossPremium),
      cgst: rupeesToNumber(values?.cgst),
      sgst: rupeesToNumber(values?.sgst),
      igst: rupeesToNumber(values?.igst),
      endorsment_file: excelFileName,
      invoice_file: pdfName,
      employee_file: empSheetName,
      // endorsement_number: values.endorsNumber,
    };
    postFormat[userPlan] = productObject;
    correctFormat[userPlan] = productObject;
    localStorage.setItem("correct_format", JSON.stringify(correctFormat));
    navigate(`/${routes.UNIVERSAL_PRODUCT_SELECT_UHID}`, {
      state: { postFormat },
    });
  };
  const calculateGrossPremium = (value) => {
    const cgst = rupeesToNumber(value?.cgst),
      igst = rupeesToNumber(value?.igst),
      sgst = rupeesToNumber(value?.sgst),
      premium = rupeesToNumber(value?.premium);
    const gross = (cgst + igst + sgst + premium).toString();
    setGrossPremium(newFormatRupees(gross));
  };
  return (
    <>
      {isLoading ? (
        <OverlayLoader />
      ) : (
        <>
          <SideNav />
          <MainBody>
            <PageTitle title={`Upload Client IDs`} />
            <WidthLimiter>
              <UploadFile
                headerMargin="12px 0"
                label="Client IDs"
                text="Upload File"
                sampleFile="UhidUploadSheet"
                format="excel"
                type="policy_upload_excel"
                onSelect={setExcelId}
                fileName={setExcelFileName}
              />
              <Divider
                style={{
                  marginTop: "30px",
                  marginBottom: "40px",
                  borderColor: "black",
                }}
              />
              <Ptag
                fontSize="20px"
                fontWeight="600"
                marginTop="5rem"
                marginBottom="40px"
              >
                Premium Invoice
              </Ptag>
              <Formik
                validationSchema={validationSchema}
                initialValues={InitialValues}
                onSubmit={uploadData}
              >
                {(formikProps) => (
                  <div style={{ marginBottom: "2.8rem" }}>
                    {calculateGrossPremium(formikProps?.values)}
                    <Form
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "2rem",
                      }}
                    >
                      <div
                        style={{
                          maxWidth: "400px",
                        }}
                      >
                        <BaseInput
                          staticLabel="Date"
                          date
                          fontSize="16px !important"
                          formikProps={{
                            ...formikProps,
                            name: "date",
                          }}
                        />
                      </div>
                      <div style={{ maxWidth: "400px" }}>
                        <BaseInput
                          staticLabel="Net Premium"
                          formatToRupee
                          fontSize="16px !important"
                          formikProps={{
                            ...formikProps,
                            name: "premium",
                          }}
                        />
                      </div>
                      <Ptag fontSize="14px" marginBottom="-5px">
                        Taxes
                      </Ptag>
                      <div
                        style={{
                          display: "flex",
                          gap: "1rem",
                          width: "800px",
                        }}
                      >
                        <div
                          style={{
                            width: "100%",
                          }}
                        >
                          <BaseInput
                            label="CGST"
                            formatToRupee
                            fontSize="16px !important"
                            formikProps={{
                              ...formikProps,
                              name: "cgst",
                            }}
                          />
                        </div>
                        <div
                          style={{
                            width: "100%",
                          }}
                        >
                          <BaseInput
                            label="SGST"
                            formatToRupee
                            fontSize="16px !important"
                            formikProps={{
                              ...formikProps,
                              name: "sgst",
                            }}
                          />
                        </div>
                        <div
                          style={{
                            width: "100%",
                          }}
                        >
                          <BaseInput
                            label="IGST"
                            formatToRupee
                            fontSize="16px !important"
                            formikProps={{
                              ...formikProps,
                              name: "igst",
                            }}
                          />
                        </div>
                      </div>
                      <DisplayBox
                        value={grossPremium}
                        label="Gross Premium (Auto Fill)"
                      />
                      <UploadFile
                        headerMargin="12px 0"
                        label={"Upload Invoice"}
                        text={"Upload File"}
                        format="pdf"
                        type="premiums_invoice"
                        onSelect={setPdfId}
                        fileName={setPdfName}
                      />
                      <Divider
                        style={{
                          marginTop: "10px",
                          marginBottom: "10px",
                          borderColor: "black",
                        }}
                      />
                      <UploadFile
                        headerMargin="12px 0"
                        label={"Employee-wise Breakup Sheet (optional)"}
                        text={"Upload File"}
                        format="excel"
                        type="employee_wise_breakup"
                        onSelect={setEmpSheet}
                        fileName={setEmpSheetName}
                      />
                      <LargeButton id="" label={"Update"} type="submit" />
                    </Form>
                  </div>
                )}
              </Formik>
            </WidthLimiter>
          </MainBody>
        </>
      )}
    </>
  );
}

export default UploadPolicyId;

const InitialValues = {
  date: "",
  // endorsNumber: "",
  premium: "",
  cgst: "",
  sgst: "",
  igst: "",
  gross_premium: "",
};

const validationSchema = Yup.object().shape({
  date: Yup.string().required("Date is required"),
  // endorsNumber: Yup.string().required("Endorsment Number is required"),
  premium: Yup.string().required("Premium is required"),
  cgst: Yup.string().required("CGST is required"),
  sgst: Yup.string().required("SGST is required"),
  igst: Yup.string().required("IGST is required"),
});
